import { render, staticRenderFns } from "./FileUploads.vue?vue&type=template&id=15230fd8"
import script from "./FileUploads.vue?vue&type=script&lang=js"
export * from "./FileUploads.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports